import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@context/AuthContext';
import { CookieConsentProvider } from '@context/CookieConsentContext';
import ErrorBoundary from '@components/ErrorBoundary';
import CookieBanner from '@components/CookieBanner';

// Pages
import Landing from '@pages/Landing';
import HowItWorks from '@pages/HowItWorks';
import Login from '@pages/Login';
import Signup from '@pages/Signup';
import NotFound from '@pages/NotFound';
import LegalPage from '@pages/legal/LegalPage';

// Tenant Pages
import TenantOnboarding from '@pages/tenant/TenantOnboarding';
import SwipeInterface from '@pages/tenant/SwipeInterface';
import Matches from '@pages/tenant/Matches';
import Chat from '@pages/tenant/Chat';
import ChatList from '@pages/tenant/ChatList';
import Profile from '@pages/tenant/Profile';
import MatchProfile from '@pages/tenant/MatchProfile';
import InquiryChat from '@pages/tenant/InquiryChat';

// Landlord Pages
import LandlordOnboarding from '@pages/landlord/LandlordOnboarding';
import LandlordDashboard from '@pages/landlord/LandlordDashboard';
import CreateProperty from '@pages/landlord/CreateProperty';
import MyProperties from '@pages/landlord/MyProperties';
import Inquiries from '@pages/landlord/Inquiries';
import RoleRoute from '@components/RoleRoute';
import GuestRoute from '@components/GuestRoute';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <CookieConsentProvider>
        <AuthProvider>
          <Routes>
          {/* Public / marketing */}
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/legal/:slug" element={<LegalPage />} />

          {/* Guest-only: signed-in users are redirected to their app */}
          <Route element={<GuestRoute />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
          </Route>

          <Route element={<RoleRoute role="roommate_seeker" />}>
            <Route path="/tenant/onboarding" element={<TenantOnboarding />} />
            <Route path="/tenant/swipe" element={<SwipeInterface />} />
            <Route path="/tenant/matches" element={<Matches />} />
            <Route path="/tenant/chat" element={<ChatList />} />
            <Route path="/tenant/chat/:matchId" element={<Chat />} />
            <Route path="/tenant/inquiry/:inquiryId" element={<InquiryChat />} />
            <Route path="/tenant/profile" element={<Profile />} />
            <Route path="/tenant/matches/:matchId/profile" element={<MatchProfile />} />
          </Route>

          <Route element={<RoleRoute role="landlord" />}>
            <Route path="/landlord/onboarding" element={<LandlordOnboarding />} />
            <Route path="/landlord/dashboard" element={<LandlordDashboard />} />
            <Route path="/landlord/create-property" element={<CreateProperty />} />
            <Route path="/landlord/properties" element={<MyProperties />} />
            <Route path="/landlord/inquiries" element={<Inquiries />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </AuthProvider>
      </CookieConsentProvider>
    </ErrorBoundary>
  );
};

export default App;
